import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
    height: 100vh;
    max-width: 400px;
    margin: 0 auto;
    @media screen and (max-width: 769px) {
        max-width: 700px;
        margin: 0;
    }
`;

export const Hr = styled.div`
    width: calc(100% + 40px);
    height: 0px;
    border: 1px solid #e7e7f0;
    margin-top: 10px;
    transform: translateX(-20px);
`;

export const Header = styled.header`
    display: flex;
    align-items: center;
`;

export const HeaderTextWrapper = styled.div``;

export const HeaderText = styled.h3``;

export const HeaderIcon = styled.div`
    margin: 10px;
`;

export const CommisionFilterWrapper = styled.div`
    margin-top: 12px;
    display: flex;
`;

export const DropDownBox = styled.div<{ is_mobile: boolean }>`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 10px 0;
    ${(props) =>
        props.is_mobile
            ? 'justify-content: space-around;'
            : 'align-items:center;'}
`;

export const CalendarWrapper = styled.div`
    margin: 10px 0;
`;

export const ErrorText = styled.p`
    font-size: 12px;
    line-height: 16px;
    margin-top: 4px;
    color: rgb(216, 61, 55);
`;

export const ListingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export const LoaderBox = styled.div`
    height: '100%';
    display: 'grid';
    place-items: 'center';
`;

export const ButtonWrapper = styled.footer`
    width: 100%;
    display: flex;
    gap: 10px;
`;
export const FilterOptionButtonWrapper = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-around;
    border: none;
    background: transparent;
`;

export const FilterOption = styled.div`
    display: flex;
    height: 300px;
    @media screen and (min-width: 768px) {
        min-width: 400px;
        height: 200px;
    }
`;

export const FilterOptionKeys = styled.div`
    width: 30%;
    display: flex;
    flex-direction: column;
    border-right: 1px solid black;
`;
export const FilterOptionKeyBox = styled.button`
    background: transparent;
    border: none;
    text-align: left;
`;
export const FilterOptionKey = styled.p`
    font-size: 18px;
    text-transform: capitalize;
`;

export const FilterOptionValues = styled.div`
    width: 70%;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
`;
export const FilterOptionValueBox = styled.button`
    background: transparent;
    border: none;
    text-align: left;
    display: flex;
    align-items: center;
`;
export const FilterOptionCheckBox = styled.div`
    border: 1px solid black;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 4px;
    padding: 3px;
`;
export const FilterOptionCheckInnerBox = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 50%;
`;
export const FilterOptionValue = styled.p`
    font-size: 16px;
    text-transform: capitalize;
`;
